import Markdoc, { Config, Schema } from "@markdoc/markdoc";
import { DataSourceInstructionVariables } from "../../helper/dataSource/getDataSourceInstructions";

export const historicalFileImportNotice: Schema = {
  render: "HistoricalFileImportNotice",
  selfClosing: true,
  transform(_node, config: Config) {
    const variables = config.variables as DataSourceInstructionVariables;

    return new Markdoc.Tag("HistoricalFileImportNotice", {
      dataSourceName: variables.dataSourceName ?? "",
    });
  },
};
